import React, { useEffect, useState, forwardRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Divider, QRCode, Image } from "antd";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Card = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var candidat = _ref.candidat;
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    id: "printable",
    style: {
      width: "495px",
      height: "308px",
      clear: "both",
      borderRadius: "4px",
      padding: "25px",
      background: "#E0D5CE"
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        "float": "left",
        width: "40%"
      },
      children: [/*#__PURE__*/_jsx(QRCode, {
        value: "https://patient.medvitale.app/#/scanpatientcode/" + candidat.candidate_code + "/" + "rio"
      }), /*#__PURE__*/_jsx("br", {})]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        "float": "right",
        width: "60%"
      },
      children: [/*#__PURE__*/_jsx(Image, {
        src: "drawables/mvtl.png",
        width: "250px",
        preview: false
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Image, {
        src: "drawables/hands.png",
        width: "150px",
        preview: false
      })]
    }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("b", {
      children: "".concat(candidat.firstname, " ").concat(candidat.lastname)
    })]
  });
});
export default Card;